import { render, staticRenderFns } from "./DialogReturnedDetails.vue?vue&type=template&id=1cb6c54e"
import script from "./DialogReturnedDetails.vue?vue&type=script&lang=js"
export * from "./DialogReturnedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports